import styled from 'styled-components';
import { Tag } from 'components/tags/styles';
import { getColor } from 'utils';
import constants from 'constants/index';

const light = constants.THEME.LIGHT;

export const TitleRow = styled('div')`
    display: inline-flex;
    align-items: center;
`;

export const UserFilterTag = styled(Tag)`
    margin-left: 0.75rem;
`;

export const DateTimeContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
`;

export const DurationCell = styled('span')`
    font-variant-numeric: tabular-nums;
    white-spacce: nowrap;
`;

export const NameContainer = styled('div')`
    min-width: 0;
    padding-right: 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const JobsHeaderContainer = styled('div')`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 1rem;

    @media (max-width: 75rem){
        align-items: flex-start;
        flex-wrap: wrap;
    }
`;

export const FilterContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    gap: 1rem;
    margin-left: auto;

    @media (max-width: 75rem) {
        width: 100%;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-left: 0;
    }
`;

export const FilterGroup = styled('div')`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 0.5rem;
    white-space: nowrap;
`;

export const FilterLabel = styled('span')`
    font-size: 0.875rem;
    color: ${props => getColor(props, 'onPrimary')};
    white-space: nowrap;
`;

export const FilterSelectContainer = styled('div')`
    width: 9rem;
`;

export const StatusSelectContainer = styled('div')`
    width: 12rem;
    min-width: 12rem;
`;

export const JobTypeSelectContainer = styled('div')`
    width: 15.5rem;
    min-width: 15.5rem;
`;

export const RefreshButton = styled('button')`
    height: 2.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0 1rem;

    color: ${props => getColor(props,'onPrimary')};
    background: transparent;
    border: 0.0625rem solid ${props => getColor(props, 'mediumGrey')};
    border-radius: 0.25rem;
    font: inherit;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: ${props =>
            getColor(
                props,
                props.$selectedTheme === light
                    ? 'lightGrey'
                    : 'darkGrey',
            )
        };
    }
    
    &:focus-visible {
        outline: 0.125rem solid ${props => getColor(props, 'accent')};
        outline-offset: 0.125rem;
    }

    &:disabled {
        cursor:  not-allowed;
        opacity: 0.5;
    }
`;

export const UploadJobButton = styled(RefreshButton)`
    flex-shrink: 0;
`;

export const UploadMenu = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
`;

export const UploadMenuLabel = styled('span')`
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    color: ${props => getColor(props, 'onPrimary')};
`;

export const FileDropLabel = styled('label')`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 3.5rem;
    padding: 0.5rem;
    border: 0.0625rem dashed ${props => getColor(props, 'mediumGrey')};
    border-radius: 0.25rem;
    font-size: 0.875rem;
    text-align: center;
    word-break: break-all;
    cursor: pointer;

    &:hover {
        border-color: ${props => getColor(props, 'accent')};
    }
`;

export const HiddenFileInput = styled('input')`
    display: none;
`;

export const UploadSubmitButton = styled(RefreshButton)`
    width: 100%;
`;

export const JobId = styled('span')`
    display: block;
    width: 100%;
    min-width: 0;
    padding-right: 0.5rem;
    color: #3da5ff;
    white-space: nowrap;
    cursor: pointer;
`;

export const RowMenuButton = styled('button')`
    width: 1.75rem;
    height: 1.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    border-radius: 0.25rem;
    background-color: transparent;
    color: ${props => getColor(props, 'onPrimary')};
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;

    &:hover {
        background-color: ${props => getColor(props, props.$selectedTheme === light ? 'lightGrey' : 'darkGrey')};
    }
`;

export const RowMenuItem = styled('a')`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.375rem 0.5rem;
    border-radius: 0.25rem;
    color: ${props => getColor(props, 'onPrimary')};
    font-size: 0.875rem;
    text-decoration: none;
    white-space: nowrap;
    opacity: ${props => (props.$disabled ? 0.4 : 1)};
    pointer-events: ${props => (props.$disabled ? 'none' : 'auto')};

    &:hover {
        background-color: ${props => getColor(props, props.$selectedTheme === light ? 'lightGrey' : 'mediumGrey')};
    }
`;

export const StatusBadge = styled('span')`
    max-width: 100%;
    min-width: 4.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    white-space: nowrap;

    color: ${props => {
        switch (props.$status?.toLowerCase()) {
            case 'completed':
                return props.$selectedTheme === light
                    ? '#1a7f37'
                    : '#39d353';
            case 'processing':
                return props.$selectedTheme === light
                    ? '#0969da'
                    : '#3da5ff';
            case 'failed':
                return props.$selectedTheme === light
                    ? '#cf222e'
                    : '#ff4d4f';
            case 'queued':
                return props.$selectedTheme === light
                    ? '#9a6700'
                    : '#ffd000';
            case 'waiting_for_file':
                return props.$selectedTheme === light
                    ? '#8250df'
                    : '#b78cff';
            default:
                return getColor(props, 'onPrimary');
        }
    }};

    background-color: ${({ $status }) => {
        switch ($status?.toLowerCase()) {
            case 'completed':
                return 'rgba(35, 134, 54, 0.18)';
            case 'processing':
                return 'rgba(45, 132, 210, 0.18)';
            case 'failed':
                return 'rgba(180, 35, 35, 0.18)';
            case 'queued':
                return 'rgba(175, 135, 0, 0.18)';
            case 'waiting_for_file':
                return 'rgba(139, 92, 246, 0.18)';
            default:
                return 'rgba(120, 125, 130, 0.18)';
        }
    }};

    border-color: ${({ $status }) => {
        switch ($status?.toLowerCase()) {
            case 'completed':
                return 'rgba(35, 134, 54, 0.65)';
            case 'processing':
                return 'rgba(45, 132, 210, 0.65)';
            case 'failed':
                return 'rgba(180, 35, 35, 0.65)';
            case 'queued':
                return 'rgba(175, 135, 0, 0.65)';
            case 'waiting_for_file':
                return 'rgba(139, 92, 246, 0.65)';
            default:
                return 'rgba(120, 125, 130, 0.65)';
        }
    }};
`;

export const TableArea = styled('div')`
    width: 100%;
    margin-top: 1rem;
    overflow-x: auto;
    border-radius: 0.25rem;
`;

export const TableFooter = styled('div')`
    width: 100%;
    min-height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
    padding-top: 0.75rem 0;
    border-top: 0.0625rem solid ${
        props => getColor(props, 'mediumGrey')
    };
`;

export const TruncatedCell = styled('div')`
    width: 100%;
    min-width: 0;
    padding-right: 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ResultSummary = styled('span')`
    color: ${props => getColor(props, 'onPrimary')};
    font-size: 0.875rem;
`;

export const RowsPerPage = styled('div')`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-left: auto;
`;

export const RowsPerPageSelect = styled('div')`
    width: 5rem;
`;

export const EmptyJobsState = styled('div')`
    min-height: 15rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 1rem;
    padding: 2rem;

    color: ${props => getColor(props, 'onPrimary')};
    border: 0.0625rem solid ${
        props => getColor(props, 'mediumGrey')
    };
    border-radius: 0.25rem;
`;

export const EmptyStateTitle = styled('div')`
    font-size: 1rem;
    font-weight: 600;
`;

export const EmptyStateText = styled('div')`
    font-size: 0.875rem;
    opacity: 0.75;
`;

export const ClearFilterButton = styled(RefreshButton)`
    margin-top: 0.5rem;
`;